import { cn } from "@/lib/utils";

const MAP = {
  pending: { label: "Pending", cls: "bg-secondary text-secondary-foreground ring-border" },
  accepted: { label: "Accepted", cls: "bg-primary/10 text-primary ring-primary/30" },
  en_route: { label: "En route", cls: "bg-[hsl(var(--info))]/10 text-[hsl(var(--info))] ring-[hsl(var(--info))]/30 animate-pulse" },
  arrived: { label: "Arrived", cls: "bg-[hsl(var(--warning))]/15 text-[hsl(var(--warning))] ring-[hsl(var(--warning))]/30" },
  completed: { label: "Completed", cls: "bg-[hsl(var(--success))]/10 text-[hsl(var(--success))] ring-[hsl(var(--success))]/30" },
  cancelled: { label: "Cancelled", cls: "bg-destructive/10 text-destructive ring-destructive/30" },
  paid: { label: "Paid", cls: "bg-foreground text-background ring-foreground/20" },
  unpaid: { label: "Unpaid", cls: "bg-secondary text-secondary-foreground ring-border" },
  approved: { label: "Approved", cls: "bg-[hsl(var(--success))]/10 text-[hsl(var(--success))] ring-[hsl(var(--success))]/30" },
  rejected: { label: "Rejected", cls: "bg-destructive/10 text-destructive ring-destructive/30" },
  none: { label: "Not verified", cls: "bg-secondary text-secondary-foreground ring-border" },
};

export function StatusChip({ status, className }) {
  const m = MAP[status] || { label: status, cls: "bg-secondary text-secondary-foreground" };
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset",
        m.cls,
        className
      )}
      data-testid={`status-chip-${status}`}
    >
      {m.label}
    </span>
  );
}
